
import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Form, Col, Row, Container } from "react-bootstrap";
import { FaCalendarAlt, FaChevronDown, FaPlus, FaMinus } from "react-icons/fa";

import DatePicker from "react-datepicker"; // Import DatePicker
import "react-datepicker/dist/react-datepicker.css"; // Import CSS for DatePicker
import {
  handleCreateRegion,
  handleGetCropList,
  handleCreateCrop,
  handleGetRegionsList,
  handleDeleteRegion,
  handleEditRegion, // ✅ Add these two
} from "../store/actions/cropActions";

import { useDispatch, useSelector } from "react-redux";
import {
  handleGetTenantData,
  handleGetTenantsData,
  handleGetTenantCropsData,
} from "../store/actions/tenantsActions";



import Loader from "../assets/images/loader.gif";
import { ICONS, IMAGES } from "../constants/constants";

const ManageRegions = () => {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear(); // Get current year
  const { regionList, cropList } = useSelector((state) => state.crop);
  const { tenantsList, tenantData, tenantCropsData,  isLoading } = useSelector(
    (state) => state.tenants
  );

  
const [editRegionId, setEditRegionId] = useState(null);
const [editRegionName, setEditRegionName] = useState("");
const [showEditModal, setShowEditModal] = useState(false);
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [regionToDelete, setRegionToDelete] = useState(null);



const handleEditClick = (region) => {
  setEditRegionId(region.id);
  setEditRegionName(region.region);
  setShowEditModal(true);
};


const submitEditRegion = async () => {
  if (editRegionName.trim() === "") {
    setErrors({ regionName: "Region name is required" });
    return;
  }

  const result = await handleEditRegion(editRegionId, { regionName: editRegionName }, dispatch);
  if (result) {
    setShowEditModal(false);
    handleGetRegionsList(dispatch);
  }
};


const handleDeleteClick = (regionId) => {
  setRegionToDelete(regionId);
  setShowDeleteModal(true);
};

const confirmDeleteRegion = async () => {
  if (regionToDelete) {
    const result = await handleDeleteRegion(regionToDelete, dispatch);
    if (result) {
      handleGetRegionsList(dispatch);
    }
    setShowDeleteModal(false);
    setRegionToDelete(null);
  }
};


  const { user } = useSelector((state) => state.user);
  const userrole = user?.role;
  const tenantId = userrole === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin

  useEffect(() => {
    // Fetch tenant data if the user is a superadmin and their ID is available
    if (tenantId) {
      dispatch(handleGetTenantData(tenantId));
      dispatch(handleGetTenantCropsData(tenantId));
    }
  }, [dispatch, tenantId]); // Use superAdminId as dependency

  const [showRegionModal, setShowRegionModal] = useState(false);
 



  const [newRegion, setNewRegion] = useState("");
 



  const [errors, setErrors] = useState({});
const [validated, setValidated] = useState(false);
const [schedualerValidated, setSchedualerValidated] = useState(false);








  useEffect(() => {
    if (!tenantsList || tenantsList.length === 0) {
      handleGetTenantsData(dispatch); // Fetch tenants list on component mount
    }
  }, [dispatch, tenantsList]);

  useEffect(() => {
    handleGetRegionsList(dispatch);
    handleGetCropList(dispatch);
  }, [dispatch]);

  const handleRegionModalShow = () => setShowRegionModal(true);
  const handleRegionModalClose = () => setShowRegionModal(false);


  const validateRegionForm = () => {
    let newErrors = {};
  
    if (newRegion.length <= 0) newErrors.regionName = "Region name is required";
    setErrors(newErrors);
    setValidated(true);
    return Object.keys(newErrors).length === 0;
  };

  const addRegion = async () => {
    

    if (!validateRegionForm()) return; 
    if (newRegion.length > 0) {
      const result = await handleCreateRegion(
        { regionName: newRegion },
        dispatch
      );
      if (result) {
        window.location.reload();
        
      }
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const options = { month: "2-digit", day: "2-digit" };
    return date.toLocaleDateString("en-US", options).replace(/\//g, "-"); // Format as MM-DD
  };


  
 






  

  // Loading state
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Container>
    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>Are you sure you want to delete this region?</Modal.Body>
  <Modal.Footer>
    <Button
      className="reject-button"
      style={{ width: "100px" }}
      variant="secondary"
      onClick={() => setShowDeleteModal(false)}
    >
      Cancel
    </Button>
    <Button
      className="button"
      style={{ backgroundColor: "red", color: "white", width: "100px" }}
      onClick={confirmDeleteRegion}
    >
      Yes
    </Button>
  </Modal.Footer>
</Modal>


   
<Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Edit Region</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form.Group>
      <Form.Label>Region Name</Form.Label>
      <Form.Control
        type="text"
        value={editRegionName}
        onChange={(e) => {
          setEditRegionName(e.target.value);
          if (errors.regionName) {
            setErrors({ ...errors, regionName: "" });
          }
        }}
        isInvalid={!!errors.regionName}
      />
      <Form.Control.Feedback type="invalid">{errors.regionName}</Form.Control.Feedback>
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="reject-button" style={{ border: "1px solid green", borderRadius: "50px" }} onClick={() => setShowEditModal(false)}>
      Cancel
    </Button>
    <Button className="button" onClick={submitEditRegion}>
      Update Region
    </Button>

   
  </Modal.Footer>
</Modal>


    <Row className="component-container mb-2">
     <Col md={12}>
     <Row>
     <Col md={6}>
        <h4>Regions ({regionList?.regions?.length || 0})</h4>
        </Col>
        <Col md={6} className="text-end">
        <Button className="button" onClick={handleRegionModalShow}>
        {ICONS?.addPlusIcon && (
                                <img src={ICONS.addPlusIcon} className="faPlusIcon" alt="Add" />
                              )}
          Add New Region
        </Button>
        </Col>
        </Row>
   <Table striped bordered hover className="mt-3">
  <thead>
    <tr>
      <th style={{ width: '83.33%' }}>Region</th> {/* 10/12 columns = 83.33% */}
      <th style={{ width: '16.67%' }}>Actions</th> {/* 2/12 columns = 16.67% */}
    </tr>
  </thead>
  <tbody>
    {regionList?.regions?.map((region) => (
      <tr key={region.id}>
        <td>{region.region}</td>
        <td className="text-center">
          <Button
            variant="link"
            className="p-0 border-0 bg-transparent me-2"
            onClick={() => handleEditClick(region)}
          >
            {ICONS?.editIcon && (
              <img src={ICONS.editIcon} className="faPlusIcon" alt="Edit" />
            )}
          </Button>
          <Button
            variant="link"
            className="p-0 border-0 bg-transparent"
            onClick={() => handleDeleteClick(region.id)}
          >
            {ICONS?.deleteIcon && (
              <img src={ICONS.deleteIcon} className="faPlusIcon" alt="Delete" />
            )}
          </Button>
        </td>
      </tr>
    ))}
  </tbody>
</Table>



      </Col>
       {/* Modals */}
       <Modal show={showRegionModal} onHide={handleRegionModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Region</Modal.Title>
          
        </Modal.Header>
        <Modal.Body>
          <p>Enter details for region</p>
          <Form.Group>
            <Form.Label>Region Name<span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              type="text"
              value={newRegion}
              onChange={(e) => {
                setNewRegion(e.target.value)
                // Clear the regionName error onChange
      if (errors.regionName) {
        setErrors({
          ...errors,
          regionName: "", // Clear the error
        });
      }
              }}
              placeholder="Enter region name"
              isInvalid={!!errors.regionName}
            />
            <Form.Control.Feedback type="invalid">{errors.regionName}</Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="w-100 d-flex justify-content-center">
          <Button className="button" style={{padding: "5px 30px"}} onClick={addRegion}>
            
            Done
          </Button>
        </Modal.Footer>
      </Modal>
      </Row>
    </ Container>
  );
};

export default ManageRegions;